/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ExamReportModalAliases {
  EXAM_REPORT_MODAL_LAYOUT = 'exam-report-modal-layout',
  LOADER_PDF = 'loader-pdf',
  PANEL_LOADER = 'panel-loader',
  PANEL_REPORT = 'panel-report',
  PDF_VIEWER = 'pdf-viewer',
}
export { ExamReportModalAliases };
